import $ from 'jquery';
import {getRestRoute, getSetting, setSetting} from "@ppcp/utils";
import apiFetch from "@wordpress/api-fetch";
import Actions from '@ppcp/actions';

class Cart {

    constructor() {
        // Initialize shared actions instance
        this.actions = new Actions();

        this.data = getSetting('cart');
        this.page = getSetting('generalData').page;
        this.processing = false;
        $(document.body).on('updated_wc_div', this.onCartUpdated.bind(this));
        $(document.body).on('updated_cart_totals', this.onCartUpdated.bind(this));
        $(document.body).on('updated_checkout', this.onUpdatedCheckout.bind(this));
        $(document.body).on('wc_fragments_refreshed wc_fragments_loaded', this.onCartFragmentsChanged.bind(this));
    }

    async onCartUpdated(e) {
        let response;
        if (window?.wcPPCPCartData?.cart) {
            response = window.wcPPCPCartData;
            this.data = {...this.data, ...response.cart};
        } else {
            response = await this.refreshData();
        }
        setSetting('queryParams', this.data.queryParams);
        this.actions.doAction('cart_updated', response, this);
        window.wcPPCPCartData = null;
    }

    /**
     * @deprecated
     * @param action
     * @param callback
     */
    on(action, callback) {
        this.actions.addAction(action, callback);
    }

    /**
     *@deprecated
     * @param action
     * @param args
     */
    trigger(action, ...args) {
        this.actions.doAction(action, ...args);
    }

    /**
     * @deprecated
     * @param event
     * @param args
     * @returns {*}
     */
    applyFilters(event, ...args) {
        return this.actions.applyFilters(event, ...args);
    }

    async onUpdatedCheckout(e, response) {
        let data = {};
        if (response?.fragments?.wc_ppcp_data) {
            data = response.fragments.wc_ppcp_data;
            const {cart, queryParams = null} = data;
            this.data = {...this.data, ...cart};
            if (queryParams) {
                setSetting('queryParams', queryParams);
            }
        }
        this.actions.doAction('updated_checkout', data, response);
    }

    onCartFragmentsChanged() {
        // fetch updated cart data
        setTimeout(() => {
            if (window.wcPPCPMiniCartUpdate) {
                this.data = {...this.data, ...wcPPCPMiniCartUpdate};
            }
            this.actions.doAction('fragments_changed', this);
        }, 250);
    }

    getData() {
        return getSetting('cart');
    }

    getCurrency() {
        return this.data.currency;
    }

    getCountryCode() {
        return this.data.countryCode;
    }

    needsShipping() {
        return this.data?.needsShipping;
    }

    isEmpty() {
        return this.data?.isEmpty;
    }

    isPaymentMethodAvailable(id) {
        return this.data?.availablePaymentMethods?.includes(id) ?? false;
    }

    async refreshData(data = null) {
        if (!this.processing) {
            try {
                this.processing = true;
                const response = await apiFetch({
                    method: 'POST',
                    url: getRestRoute('cart/refresh'),
                    data: {page: this.page},
                });
                this.data = {...this.data, ...response.cart};
                this.data.queryParams = response.queryParams;
                return response;
            } catch (error) {
                console.log(error);
            } finally {
                this.processing = false;
            }
        }
    }

    async addToCart(data) {
        return apiFetch({
            method: 'POST',
            url: getRestRoute('cart/item'),
            data: this.actions.applyFilters('add_to_cart_data', data, this)
        }).then(response => {
            return response;
        }).catch(error => {
            throw error;
        })
    }

    /**
     * Update shipping method and/or address
     * @param {Object} data - Shipping update data
     * @param {Object} data.address - Shipping address (city, postcode, state, country)
     * @param {string} data.shipping_method - Selected shipping method ID
     * @returns {Promise<Object>} Updated cart data with totals and shipping options
     */
    async updateShipping(data) {
        return apiFetch({
            method: 'POST',
            url: getRestRoute('cart/shipping'),
            data
        }).then(response => {
            return this.sanitizeResponse(response);
        }).catch(error => {
            throw error;
        });
    }

    async createOrder(data) {
        return apiFetch({
            method: 'POST',
            url: getRestRoute('cart/order'),
            data
        }).then(orderId => {
            return this.sanitizeResponse(orderId);
        });
    }

    async doOrderPay(payment_method, data = {}) {
        const order = getSetting('order');
        return apiFetch({
            method: 'POST',
            url: getRestRoute('order/pay'),
            data: {
                payment_method,
                ...data,
                ...order
            }
        }).then(response => this.sanitizeResponse(response));
    }

    getTotal() {
        return this.data?.total;
    }

    sanitizeResponse(response) {
        if (typeof response === 'string') {
            response = response.replace(/<[^>]*>/g, '');
        } else if (Array.isArray(response)) {
            // some 3rd party plugins manipulate the WordPress REST API response
            // and make it an array
            response = this.sanitizeResponse(response[0]);
        }
        return response;
    }
}

export default new Cart();